import { useWindowWidth } from "@react-hook/window-size";
import { Checkbox, Collapse, Form, message, Modal, Table } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { serverFetch } from "../../server";
import { PayButtons } from "../../controls";

const { Panel } = Collapse;

const HistoryPayDebet = ( { syma, services, onClose, needAutopay } ) => {
  const user = useSelector((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const company = useSelector((s) => s.company);
  const onlyWidth = useWindowWidth();
  const [cond3, setCond3] = useState(false);

  const onSave = (paymentSystem) => {
    setLoading(true);
    serverFetch("payment/debet", {method: "POST", bodyData: {saleId: 0, paymentSystem, autopay: needAutopay }}, user)
      .then(data => {
        if (data) onClose(data);
        else {
          setLoading(false);
          message.error("Ошибка")
        }
      })
      .catch(data => {
        message.error(data.UserMessage)
        setLoading(false);
      })
  }
  
  const cols = [
    { dataIndex: "tovName", title: "Наименование" },
    { dataIndex: "qty", title: "Кол.", align: "center" },
    { dataIndex: "syma", title: "Сумма", align: "right" },
  ]

  const offerAutopay = company && company.offerAutopay ? company.offerAutopay : process.env.REACT_APP_OFFER_AUTOPAY;
  const divAutopayCondition = needAutopay ? <Panel header="Условия сервиса “Автоплатеж”" key="3">
      Условия пользования сервисом «Автоплатеж» в соответствии со ст.435 ГК РФ являются офертой, адресованной Пользователю. Пользователь, как держатель банковской карты, 
      производя оплату соглашается с <a href={offerAutopay} target='_blank' rel="noreferrer">Условиями</a>
  </Panel> : null
  const divAutopay = needAutopay ? <Checkbox onChange={(e) => setCond3(e.target.checked)} checked={cond3}>Я согласен с сохранением данных карты и условиями сервиса "Автоплатеж"</Checkbox> : null

  return<Modal open onClose={() => onClose()} onCancel={() => onClose()} loading={loading} title="Оплата долга" closable={false} footer={null}>
    <Form colon={false} form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} disabled={loading} size="middle">
      <Table dataSource={services} columns={cols} pagination={false}/>
      <Collapse size="small" accordion>{divAutopayCondition}</Collapse>
      {divAutopay}
      {company && <PayButtons 
        company={company}
        isMobile={onlyWidth < 700}
        onPay={onSave}
        disablePayment={loading || (needAutopay && !cond3)}
        autopay={needAutopay}
        price={syma}
        onBack={onClose} />}
    </Form>
  </Modal>
}

export default HistoryPayDebet;